/**
 * Estilos de los tableros de control, como objetos inline.
 *
 * No se usa styles.module.css a propósito: microbundle emite las clases hasheadas a
 * dist/index.css, un archivo que ningún consumidor del módulo importa, así que en el build
 * desplegado las reglas nunca llegan al navegador. El resto del módulo ya resuelve el estilo
 * con `style={{...}}` por la misma razón.
 */

export const headerCard = {
    backgroundColor: '#4F517A',
    color: 'white'
};

export const filtroPanel = {
    backgroundColor: '#f8f9fa',
    borderRadius: '0.375rem',
    padding: '1rem',
    marginBottom: '1rem'
};

export const chartContainer = {
    minHeight: 280
};

/** El color del borde lo define cada tarjeta según su indicador. */
export const kpiCard = {
    borderLeft: '4px solid'
};

export const kpiValue = {
    fontSize: '1.5rem',
    fontWeight: 700,
    lineHeight: 1.2
};

export const kpiLabel = {
    fontSize: '0.78rem',
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    color: '#6c757d'
};

/**
 * Los dos bloques del tablero Inter Compañía (V1.1, RG-541).
 * 🟠 ámbar = lo que refleja el estado de HOY, sin filtro de período.
 * 🔵 azul  = lo que ocurrió DENTRO del rango de meses elegido.
 * El color es la señal de que son dos lecturas distintas: mezclarlas fue lo que motivó el rediseño.
 */
export const grupoActual = {
    background: '#fff8ea',
    border: '1px solid #f5e0b4',
    borderRadius: '0.375rem',
    padding: '0.5rem',
    height: '100%'
};

export const grupoPeriodo = {
    background: '#eef4ff',
    border: '1px solid #c8dcff',
    borderRadius: '0.375rem',
    padding: '0.5rem',
    height: '100%'
};

export const COLOR_GRUPO_ACTUAL = '#b8770d';
export const COLOR_GRUPO_PERIODO = '#1e4fa8';

/** Encabezado de cada bloque: título en versalitas sobre una línea del color del grupo. */
export const grupoHeader = (color) => ({
    display: 'flex',
    alignItems: 'baseline',
    gap: '0.5rem',
    marginBottom: '0.5rem',
    paddingBottom: '0.25rem',
    borderBottom: `2px solid ${color}`
});

export const grupoTitulo = (color) => ({
    color,
    textTransform: 'uppercase',
    fontWeight: 700,
    fontSize: '0.8rem',
    letterSpacing: '0.5px'
});

export const grupoSubtitulo = {
    color: '#6c757d',
    fontSize: '0.72rem'
};
